import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey } from './reducers/feature-key';
import { genesysCloudWebDeploymetsReducer } from './reducers/web-deployment.reducers';
import { GenesysCloudConfigurationEffects } from './effects/configuration.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudWebDeploymetsReducer),
    EffectsModule.forFeature([
      GenesysCloudConfigurationEffects
    ])
  ]
})
export class GenesysCloudWebDeploymentsModule {
}
